/* eslint-disable max-len */
import type { TranslationMessages } from '~/definitions/Translations'

const es: TranslationMessages = {
  ACCEPT: 'Aceptar',
  ACCEPTED: 'Aceptado',
  ACCEPTED_NEW: 'Aceptado',
  ACCOUNT: 'Cuenta',
  ACCOUNT_SETTINGS: 'Configuración de Cuenta',
  ACTIVE: 'Activo',
  ACTIVE_ORDERS: 'Ordenes activas',
  ADDITIONAL_CHARGE: 'Cargo adicional',
  ADDITIONAL_COMMENTS: 'Comentarios adicionales',
  ADDITIONAL_MINUTES: 'Minutos adicionales',
  ADDITIONAL_NOTES: 'Notas adicionales',
  ADDRESS: 'Dirección',
  ADDRESSES: 'Direcciones',
  ADDRESS_CITY_OR_ZIP: 'Dirección, ciudad o código postal',
  ADDRESS_INELIGIBLE_DELIVERY: 'Lo sentimos, ésta dirección /está fuera del radio de entrega. Favor de ingresar otra dirección.',
  ADDRESS_INELIGIBLE_DELIVERY_PICK_UP_AVAILABLE: 'Lo sentimos, ésta /dirección está fuera del radio de entrega. Favor de ingresar /otra dirección o seleccionar Recogida.',
  ADDRESS_LINE_2: 'Línea de dirección 2',
  ADDRESS_LINE_2_HINT: 'Ingresar Suite, Apt, Número, etc.',
  ADDRESS_LINE_THREE: 'Línea de dirección 3',
  ADDRESS_NOT_DELIVERABLE: 'Entrega no disponible para esta dirección. /Favor de ingresar una dirección diferente o elegir recogida.',
  ADDRESS_TYPE: 'Tipo de dirección',
  ADD_ADDRESS: 'Agregar dirección',
  ADD_EXISTING_CART: 'Agregar a bolsa existente',
  ADD_EXTRA: 'Agregar un extra',
  ADD_HOURS: 'Agregar horario',
  ADD_MENU_CATEGORY: 'Agregar categoría de menú',
  ADD_MENU_ITEM: 'Agregar elemento al menú',
  ADD_MODIFIER: 'Agregar modificador',
  ADD_NEW: 'Agregar Nuevo',
  ADD_NEW_CARD: 'Agregar Nueva Tarjeta',
  ADD_NEW_CATEGORY: 'Agregar nueva categoría',
  ADD_NEW_F: 'Agregar nueva { value }',
  ADD_NEW_M: 'Agregar nuevo { value }',
  ADD_PAYMENT_METHOD: 'Agregar Forma de Pago',
  ADD_TIP: 'Agregar propina',
  ADD_TO_CART: 'Agregar al carrito',
  ADD_TO_CART_ERROR: 'Se ha producido un error al añadir este artículo a tu/ carrito. Inténtalo de nuevo más tarde.',
  ADD_USER: 'Agregar usuario',
  ADJUST_ORDER_TIME: 'Ajustar el tiempo de la orden',
  ADJUST_TIME: 'Ajustar tiempo',
  ADMIN: 'Administrador',
  ADMINISTRATOR: 'Administrador',
  ALL: 'Todo',
  ALLERGY_FRIENDLY: 'Apto para alergias',
  ALLOW_DELIVERY: 'Permitir entrega',
  ALLOW_PICKUP: 'Permitir recogida',
  ALL_DISHES: 'Todos los platillos',
  ALL_TIME: 'Todo el tiempo',
  ALREADY_HAVE_ACCOUNT: '¿Ya tienes una cuenta?',
  AM: 'a.m.',
  ANALYTICS: 'Analítica',
  AND: 'y',
  APPLY: 'Aplicar',
  ARCHIVE: 'Archivar',
  ARCHIVED: 'Archivada',
  ARCHIVE_ACCOUNT: 'Archivar cuenta',
  ARCHIVE_LOCATION: 'Archivar ubicación',
  ARE_YOU_SURE_DELETE_ADDRESS: '¿Estás seguro de que quieres eliminar esta dirección?',
  ARE_YOU_SURE_DELETE_PAYMENT_METHOD: 'Al confirmar, {cardBrand} que termina en {lastFour} será eliminada como forma de pago. Esto no cancelará cualquier orden en proceso que haya utilizado esta forma de pago.',
  ASAP_DELIVERY_X: 'Inmediato ({value} minutos)',
  AVAILABILITY: 'Disponibilidad',
  AVAILABLE: 'Disponible',
  AVAILABLE_ALL_ORDERING_HOURS: 'Disponible durante el horario para ordenar',
  AVG_REVENUE_PER_ORDER: 'Promedio de ingresos por orden',
  BACK: 'Atrás',
  BACK_TO_HOME: 'Regresar al inicio',
  BILLING: 'Facturación',
  BILLING_ADDRESS: 'Dirección de facturación',
  BILLING_DELIVERY: 'Facturación y entrega',
  BILLING_DELIVERY_ADDRESS: 'Dirección de facturación y entrega',
  BUSINESS_HOURS: 'Horas de oficina',
  BUSINESS_HOURS_DESC: 'Establece el horario comercial de tu restaurante',
  BUSINESS_NAME: 'Nombre de la empresa',
  BUSINESS_NAME_REQ: 'Se requiere el nombre de la empresa',
  BUY_AGAIN: 'Comprar de nuevo',
  CALL_US_AT: 'Llámanos al',
  CANCEL: 'Cancelar',
  CANCELLED: 'Cancelado',
  CARD_DECLINED: 'Tu tarjeta fue rechazada',
  CARD_NUMBER: 'Número de Tarjeta',
  CARD_NUMBER_REQ: 'Se requiere un número de tarjeta',
  CARD_UPDATE_ERROR: 'No se pudo actualizar la tarjeta',
  CARD_X_ENDING_Y: '{cardBrand} terminando en {lastFour}',
  CART_ITEM: 'Artículo del carrito',
  CATEGORIES: 'Categorías',
  CATEGORY: 'Categoría',
  CHANGE_LOCATION: 'Cambiar ubicación',
  CHANGE_LOCATION_WARNING: 'Al cambiar de ubicación se vaciará tu carrito. ¿Deseas continuar?',
  CHANGE_PASSWORD: 'Cambiar Contraseña',
  CHANGE_PASSWORD_DESCRIPTION: 'Actualiza la contraseña asociada a tu cuenta.',
  CHANGE_PASSWORD_FOR: 'Cambiar Contraseña para',
  CHARGE_DELIVERY_ALL_ORDERS: 'Cobrar costos de entrega en todas las órdenes',
  CHECKOUT: 'Pagar',
  CHECKOUT_GUEST_DESCRIPTION: 'o continúa con la compra como <strong>invitado</strong>',
  CHECK_YOUR_EMAIL: 'Revisa tu correo electrónico',
  CHOOSE_PICKUP: 'Elige recogida',
  CITY: 'Ciudad/Pueblo',
  CITY_OR_ZIP: 'Ciudad o código postal',
  CITY_REQ: 'Favor de ingresar la ciudad',
  CLEAR: 'Borrar',
  CLEAR_SEARCH: 'Borrar Resultados de Búsqueda',
  CLICK_BUTTON_BELOW_RESET: 'Haz clic en el botón abajo para restablecerla.',
  CLOSE: 'Cerrar',
  CLOSED: 'Cerrado',
  CLOSES_AT: 'Cierra a las',
  CLOSE_PANEL: 'Cerrar panel',
  COMPLETE: 'Completar',
  COMPLETED: 'Completado',
  COMPLETED_ON_X: 'Completada en {date}',
  COMPLETED_ORDERS: 'Ordenes completadas',
  CONFIRM_NEW_PASSWORD: 'Confirmar contraseña',
  CONFIRM_ORDER: 'Confirmar orden',
  CONFIRM_ORDER_X: 'Confirmar orden #{orderId}',
  CONFIRM_PASSWORD: 'Confirmar Contraseña',
  CONFIRM_TIME: 'Confirmar tiempo',
  CONTACT_DETAILS: 'Detalles de Contacto',
  CONTACT_FREE_DELIVERY: 'Entrega sin contacto',
  CONTACT_FREE_DELIVERY_DESC: 'Elige esta opción para que tu orden sea entregada y recibir una notificación',
  CONTACT_FREE_DELIVERY_X: 'Entrega sin contacto a {value}',
  CONTACT_INFORMATION: 'Información de contacto',
  CONTACT_US: 'Contáctanos',
  CONTAINS_NUTS: 'Contiene nueces',
  CONTINUE: 'Continuar',
  CONTINUE_AS_GUEST: 'Continuar como invitado',
  CONTINUE_CHECKOUT: 'Continuar la compra',
  CONTINUE_CHECKOUT_VALUE: 'Continuar a la caja: {value}',
  CONTINUE_GUEST: 'Continuar como invitado',
  CONTINUE_GUEST_DESC: 'No necesitas una cuenta para pagar',
  CONTINUE_PAYMENT: 'Continuar a pagar',
  CONTINUE_SHOPPING: 'Continuar comprando',
  COUNTRY: 'País',
  CREATE: 'Crear',
  CREATE_ACCOUNT: 'Crea tu cuenta',
  CREATE_ACCOUNT_ALT: 'Crear cuenta',
  CREATE_ACCOUNT_CHECKOUT_DISCLAIMER: 'Al crear una cuenta, aceptas nuestros términos',
  CREATE_ACCOUNT_DESC: '¿Aún no tienes cuenta?',
  CREATE_ACCOUNT_FASTER_CHECKOUT: 'Crea una cuenta para pagar más rápido la próxima vez',
  CREATE_ONE: 'Crear una',
  CREDITED_TO: 'Creditado a',
  CURBSIDE_PICKUP: 'Permitir recogida en la acera',
  CURBSIDE_PICKUP_AT: 'Recogida en la acera en {value}',
  CURBSIDE_PICKUP_CUSTOMER_DESC: 'Elige esta opción para que un miembro de nuestro personal lleve la orden a tu vehículo.',
  CURBSIDE_PICKUP_DESC: 'Permite que los clientes recojan su orden en la acera y notificarlos para que llamen cuando lleguen a la localidad.',
  CURBSIDE_PICKUP_X: 'Recogida en la acera desde {value}',
  CURRENTLY_NOT_ACCEPTING_ONLINE_ORDERS: 'Lo sentimos, actualmente no estamos aceptando pedidos en línea',
  CURRENTLY_UNAVAILABLE: 'Actualmente no disponible',
  CURRENT: 'Actual',
  CURRENT_PASSWORD: 'Contraseña Actual',
  CURRENT_PASSWORD_REQUIRED: 'Se requiere la contraseña actual para cambiar la contraseña',
  CUSTOM: 'Personalizado',
  CUSTOMER_MAY_NOT_SEE_REFUND_FOR_5_10_DAYS: 'Es posible que el cliente no vea este reembolso durante 5-10 días',
  CUSTOMER_REQUESTS_CONTACT_FREE_DELIVERY: 'El cliente ha solicitado entrega sin contacto',
  CUSTOMER_WILL_RECEIVE_NOTIFICATION_ADJUSTED_TIME: 'El cliente recibirá una notificación con la nueva hora ajustada',
  CUSTOM_ORDERING_HOURS: 'Horas de pedido personalizadas',
  CUSTOM_ORDERING_HOURS_DESC: 'Activa esto para anular y establecer horas de pedido personalizadas.',
  CUSTOM_TIME: 'Tiempo personalizado',
  CUSTOM_TIP_AMOUNT: 'Cantidad de propina personalizada',
  CVC: 'Código CVC',
  DARK: 'Oscuro',
  DAY: 'Día',
  DEFAULT_BILLING_DELIVERY: 'Dirección de facturación y entrega predeterminada',
  DEFAULT_STORE_LOCATION: 'Ubicación de tienda predeterminada',
  DEFAULT_X: '{value} predeterminado',
  DELETE: 'Borrar',
  DELETE_ACCOUNT: 'Eliminar cuenta',
  DELETE_ACCOUNT_CONFIRMATION: '¿Estás seguro de que quieres desactivar tu cuenta? Todos tus datos se eliminarán permanentemente de nuestros servidores para siempre. Esta acción no se puede deshacer.',
  DELETE_ACCOUNT_DESCRIPTION: '¿Ya no quieres usar nuestro servicio? Puedes eliminar tu cuenta aquí. Esta acción no es reversible. Toda la información relacionada con esta cuenta se eliminará permanentemente.',
  DELETE_ACCOUNT_YES: 'Sí, eliminar mi cuenta',
  DELETE_ADDRESS: 'Eliminar esta dirección',
  DELETE_PAYMENT_METHOD: '¿Eliminar esta forma de pago?',
  DELETE_PAYMENT_METHOD_DESC_X: 'Al confirmar, la tarjeta {cardType} terminando en {lastFour} será eliminada de tus formas de pago. Esto no cancelará órdenes abiertas que usen esta forma de pago.',
  DELIVER: 'Entrega',
  DELIVERED: 'Entregado',
  DELIVERY: 'Envío',
  DELIVERY_AREA_RADIUS_MI: 'Radio de entrega (millas)',
  DELIVERY_AT: 'Entrega a',
  DELIVERY_FEE: 'Gastos de envío',
  DELIVERY_FEES: 'Costo de entrega',
  DELIVERY_FEE_AMOUNT: 'Cantidad de costo de entrega',
  DELIVERY_FEE_DEFAULT: 'Costo de entrega para las demás órdenes',
  DELIVERY_INFORMATION: 'Información de entrega',
  DELIVERY_INSTRUCTIONS: 'Instrucciones de envío',
  DELIVERY_PICKUP_ADDRESSES: 'Direcciones de entrega / recogida',
  DELIVERY_TIME: 'Tiempo de entrega',
  DELIVERY_TO: 'ENTREGA a',
  DELIVERY_TO_X: 'Entrega a {value}',
  DELIVERY_X: 'Entrega a {value}',
  DELIVER_IN: 'Entrega en',
  DESCRIPTION: 'Descripción',
  DETAILS: 'Detalles',
  DIETARY_OPTIONS: 'Opciones dietéticas',
  DISCOUNT: 'Descuento',
  DISCOUNT_CODE: 'Código de descuento',
  DISMISS_ALERT: 'Descartar alerta',
  DONT_HAVE_ACCOUNT: '¿Aún no tienes cuenta?',
  EDIT: 'Editar',
  EDIT_ADDRESS: 'Editar dirección',
  EDIT_CATEGORY: 'Editar la categoría',
  EDIT_F: 'Editar {value}',
  EDIT_IMAGE: 'Editar imagen',
  EDIT_MENU_ITEM: 'Editar elemento del menú',
  EDIT_ORDER: 'Cambiar orden',
  EDIT_PAYMENT_METHOD: 'Editar el método de pago',
  EDIT_USER: 'Editar Usuario',
  EMAIL: 'Correo electrónico',
  EMAIL_ADDRESS: 'Correo electrónico',
  EMAIL_CONFIRMATION_WITH_PASSWORD: 'Se enviará una confirmación con la contraseña a este correo electrónico',
  EMAIL_SENT_TO: 'Correo electrónico enviado a',
  EMAIL_THANK_YOU_FOR_REGISTERING: 'Gracias por registrarte con {value}. Ahora puedes ingresar a tu cuenta para realizar tus órdenes más rapido.',
  EMAIL_WELCOME_NEW_STORE_USER: 'Has sido agregado como usuario en {value}. Para activar tu cuenta, haz clic en el botón a continuación',
  EMPTY_BAG: 'Vaciar bolsa',
  EMPTY_CART: 'Carrito vacío',
  ENABLE_MARKETING_NOTIFICATIONS: 'Permitir notificaciones de mercadeo',
  ENABLE_MARKETING_NOTIFICATIONS_DESCRIPTION: 'Recibir mensajes de texto sobre nuevos productos, descuentos y ventas',
  ENABLE_PRINTER: 'Habilitar impresora',
  ENABLE_PRINTER_DESC: 'Activar para enviar una copia de cada recibo de pedido a la impresora',
  ENABLE_SMS_NOTIFICATIONS: 'Permitir notificaciones por SMS',
  ENABLE_SMS_NOTIFICATIONS_DESCRIPTION: 'Recibir notificaciones por SMS sobre mis pedidos',
  END_DATE: 'Fecha Final',
  ENTER_EXPIRATION_DATE: 'Ingresa la fecha de expiración',
  ENTER_LOCATION_DETAILS: 'Ingresar ciudad, estado o código postal',
  ENTER_NAME_EMAIL: 'Ingresa un nombre o correo electrónico',
  ENTER_NEW_PASSWORD: 'Ingresa nueva contraseña',
  ENTER_PASSWORD: 'Ingresa una contraseña',
  ENTER_STRONGER_PASSWORD: 'Debes ingresar una contraseña más segura',
  ENTER_VALID_CVC: 'Debes ingresar un código CVC válido',
  ENTER_VALID_EMAIL: 'Ingresa un correo electrónico válido',
  ENTER_VALID_EXPIRATION_DATE: 'Ingresa una fecha de expiración válida',
  ENTER_VALID_NUMBER: 'Ingresa un número válido. (Sólo se permiten números y decimales)',
  ENTER_VALID_POSTAL_CODE: 'Ingresa un código postal válido',
  ENTER_YOUR_EMAIL: 'Favor de introducir su correo electrónico',
  ERROR_PROCESSING_PAYMENT_CUSTOMER_WILL_BE_NOTIFIED: 'Hubo un error al procesar el pago de esta orden. Se notificará al cliente.',
  ESTIMATED_DELIVERY_TIME_X: 'Calculamos que estará lista para entrega a las {value} y se recibirá poco después.',
  ESTIMATED_PICKUP_TIME_X: 'Calculamos que estará lista para recoger a las {value}.',
  EXPIRED_CARD: 'Tu tarjeta ha expirado',
  EXPIRES: 'Expira',
  EXPRESS_CHECKOUT: 'Pago rápido',
  EXP_DATE: 'Fecha de expiración',
  EXTRAS: 'Extras',
  EXTRAS_ARE_X: 'Los extras cuestan {value} cada uno',
  FEES: 'Tarifas',
  FIELD_REQ: 'Este campo es requerido',
  FILL_REQ_FIELDS: 'Por favor llena todos los campos requeridos',
  FIND_LOCATION: 'Encontrar ubicación',
  FIND_STORE: 'Buscar tienda',
  FIRST_NAME: 'Nombre',
  FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
  FRAUDULENT: 'Fraudulento',
  FREE: 'GRATIS',
  FREE_DELIVERY: 'Entrega gratuita',
  FREE_DELIVERY_MIN_AMOUNT: 'Cantidad mínima para entrega gratuita',
  FREE_DELIVERY_MIN_X: '{value} mínimo para entrega GRATIS',
  FRI: 'Viernes',
  FRIDAY: 'Viernes',
  FULL_HOURS: 'Horas completas',
  GENERAL_SETTINGS: 'Configuración general',
  GETTING_COOKED: 'Cocinando',
  GET_STARTED_DELIVERY_METHOD: 'Para comenzar, selecciona una opción.',
  GET_STARTED_ENTER_ADDRESS: 'Para comenzar, ingresa tu dirección.',
  GLUTEN_FREE: 'Sin gluten',
  GMB_ENTER_LOCATION_HINT: 'Introduce la primera línea de la dirección, excluyendo Suite, Apartamento, Número, etc.',
  GO_TO_CHECKOUT: 'Ir a pagar',
  GRATUITY: 'Propina',
  GRATUITY_DESC: 'Permitir que los clientes dejen una propina al pagar.',
  HIDE_DETAILS: 'Ocultar detalles',
  HOME: 'Inicio',
  HOURS_FOR_X: 'Horas para {value}',
  IMAGE: 'Imagen',
  IMAGES_SELECTED_X: '({number}) imágenes seleccionadas.',
  IMPORTANT_ORDER_UPDATE: 'Información importante sobre tu orden',
  INCOMING: 'Entrante',
  INCOMPLETE_CARD_NUMBER: 'Número de tarjeta incompleto',
  INCOMPLETE_CVC: 'Tu tarjeta',
  INCOMPLETE_EXPIRY: 'Tu tarjeta',
  INCOMPLETE_NUMBER: 'El número de tarjeta está incompleto.',
  INCORRECT_CVC: 'El código de seguridad de tu tarjeta es incorrecto',
  INSTALL_APP: 'Añadir a pantalla de inicio',
  INVALID_CREDENTIALS: 'La contraseña y/o el nombre de usuario que ingresaste son incorrectos',
  INVALID_CURRENT_PASSWORD: 'La contraseña actual es incorrecta',
  INVALID_DISCOUNT_CODE: '{value} no es un código de descuento válido',
  INVALID_EXPIRY_MONTH: 'El mes de vencimiento de la tarjeta no es válido',
  INVALID_EXPIRY_YEAR: 'El año de vencimiento de la tarjeta no es válido.',
  INVALID_EXPIRY_YEAR_PAST: 'El año de vencimiento de la tarjeta está en el pasado',
  INVALID_NUMBER: 'El número de tarjeta no es válido',
  INVALID_PHONE_NUMBER: 'Número de teléfono inválido',
  INVALID_TOKEN: 'El token para restablecer la contraseña no es válido o ha expirado.',
  IN_PROGRESS: 'En Progreso',
  IN_PROGRESS_ORDERS: 'Ordenes en proceso',
  IN_STOCK: 'En existencia ',
  IN_TRANSIT: 'En ruta',
  ITEMS_SUBTOTAL: 'Subtotal de artículos',
  ITEM_CURRENTLY_OUT_OF_STOCK: 'Este artículo no está disponible en este momento',
  ITEM_ONLY_AVAILABLE_ON: 'Este artículo solo está disponible los {days}',
  I_COME_INSIDE: 'Entro',
  KITCHEN_CLOSED: 'Cocina cerrada',
  LAST30DAYS: 'Últimos 30 días',
  LAST7DAYS: 'Últimos 7 días',
  LAST_NAME: 'Apellido',
  LAST_WEEK: 'Última Semana',
  LIGHT: 'Claro',
  LIMITED_AVAILABILITY: 'Disponibilidad limitada',
  LINK: 'Enlace',
  LOADING_X: 'Cargando {value}...',
  LOCATIONS: 'Localidades',
  LOCATION_DETAILS: 'Detalles de localidad',
  LOCATION_MANAGER: 'Gerente de tienda',
  LOCATION_NAME: 'Nombre de localidad',
  LOCATION_SETTINGS: 'Configuración de ubicación',
  LOGIN: 'Ingresar',
  LOG_IN_TO_YOUR_ACCOUNT: 'Ingresa a tu cuenta',
  LOG_OUT: 'Cerrar Sesión',
  LOW_CALORIE: 'Bajo en calorías',
  MAC_ADDRESS: 'Dirección MAC',
  MAKE_THIS_YOUR_STORE: 'Marcar como mi tienda',
  MANAGE_ORDERS: 'Administrar órdenes',
  MANAGE_USERS: 'Administrar Usuarios',
  MANAGE_USER_PERMISSIONS: 'Administrar permisos de usuarios',
  MARK_ALL_READ: 'Marcar todo como leído',
  MENU_CATEGORY_NAME: 'Nombre de la categoría del menú',
  MENU_ITEM: 'Opción del menú',
  MENU_ITEMS_ECOM: 'Elementos del menú',
  MENU_ITEM_ECOM: 'Elemento del menú',
  MENU_ITEM_GROUP_EXTRAS_DESC: 'Opciones o ingredientes adicionales (ej. añadir queso)',
  MENU_ITEM_GROUP_MODIFIERS_DESC: 'Ingredientes u opciones que se pueden eliminar (ej. sin cebolla)',
  MENU_ITEM_GROUP_OPTS_DESC: 'Opciones variadas para que un cliente seleccione (ej. pollo o carne)',
  MESSAGE_FROM_RESTAURANT: 'Mensaje del restaurante',
  MINUS_ONE: 'Menos uno',
  MINUTES: 'minutos',
  MIN_ORDER_AMOUNT: 'Cantidad mínima para ordenar',
  MODIFIERS: 'Modificadores',
  MON: 'Lunes',
  MONDAY: 'Lunes',
  MONTH: 'Mes',
  MOST_RECENT: 'Más reciente',
  MY_ACCOUNT: 'Mi Cuenta',
  MY_ORDERS: 'Mis Ordenes',
  NAME_ON_CARD: 'Nombre en la tarjeta',
  NET_AMOUNT: 'Importe neto',
  NEW: 'Nuevos',
  NEWEST_FIRST: 'Más recientes',
  NEW_CUSTOMERS: 'Nuevos clientes',
  NEW_ORDER: 'Nueva orden',
  NEW_ORDERS: 'Nuevas Órdenes',
  NEW_PASSWORD: 'Nueva contraseña',
  NEW_PASSWORD_AVAILABLE_DESC: 'Ahora puedes usar tu nueva contraseña para ingresar a tu cuenta.',
  NEW_SCHEDULED_ORDER: 'Nueva orden programada',
  NEXT: 'Siguiente',
  NONE: 'Ninguno',
  NOTE_TO_CUSTOMER_OPT: 'Nota al cliente (opcional)',
  NOTIFICATIONS: 'Notificaciones',
  NOT_ACCEPTING_ORDERS: 'Actualmente no se aceptan pedidos',
  NOT_AVAILABLE: 'No disponible',
  NOT_A_MEMBER: '¿No eres miembro?',
  NOT_NOW: 'Por ahora no',
  NO_CONTACT_DELIVERIES: 'Entregas sin contacto',
  NO_CONTACT_DELIVERIES_DESC: 'Permite que los clientes elijan entrega sin contacto y agreguen instrucciones para el repartidor.',
  NO_MATCH_PASSWORDS: 'La nueva contraseña no coincide con la confirmación de contraseña',
  NO_ORDERS: 'No hay pedidos',
  NO_PAID_ORDERS: 'No órdenes pagadas',
  NO_PRODUCTS_FOUND: 'No hay productos',
  NO_REVENUE: 'No ingresos',
  NO_USERS_FOUND_WITHIN_CRITERIA: 'No se econtraron usuarios bajo este criterio de búsqueda',
  NO_X_FOUND_FILTER: 'No se encontraron {value} bajo este criterio de búsqueda',
  OK: 'OK',
  OLDEST: 'Más antiguo',
  OLDEST_FIRST: 'Más antiguos',
  ONE_ITEM: '1 artículo',
  ONE_ITEM_IN_YOUR_BAG: '1 artículo en la bolsa',
  ONE_MINUTE: '1 minuto',
  ONLINE_ORDERING: 'Pedidos en línea',
  ONLINE_ORDERING_HINT: '<strong>¡ADVERTENCIA!</strong> Desactivar esta opción se anulará cualquier horario establecido. Los clientes aún podrán ver el menú pero no podrán hacer órdenes.',
  OPEN: 'Abierto',
  OPENS_AT: 'Abierto',
  OPEN_ALL_WEEK: 'Servicio 24/7',
  OPTION: 'Opción',
  OPTIONAL: '(Opcional)',
  OPTIONS: 'Opciones',
  OR: 'o',
  ORDER: 'Órden',
  ORDERING_HOURS: 'Horario para ordenar',
  ORDERING_HOURS_DESC: 'El horario para ordenar se calcula automáticamente basado en las horas de trabajo y el tiempo de preparación.',
  ORDERING_HOURS_DISCLAIMER: 'Recuerda considerar el tiempo para cocinar / preparar al elegir las horas de pedido. Por ejemplo, si normalmente cierras la cocina del restaurante a las 5pm, fija el último pedido a las 4:30pm para permitir la preparación.',
  ORDERS: 'Órdenes',
  ORDERS_X: 'Ordenes para {value}',
  ORDER_ACCEPTED_DESC: '¡Exelentes noticias! Tu orden fue aceptada por el restaurante. Estamos trabajando en tu pedido y te notificaremos cuando esté listo.',
  ORDER_ACCEPTED_HEADLINE: '¡Tu pedido está siendo preparado!',
  ORDER_AMOUNT: 'Total de la orden',
  ORDER_BEING_PREPPED_ETA: 'Tu orden está siendo procesada con un tiempo de preparación de',
  ORDER_DELIVERED_DESC: 'Tu orden ha sido entragada a',
  ORDER_DELIVERED_HEADLINE: 'Tu orden ha sido entregada',
  ORDER_DETAILS: 'Detalles de la Orden',
  ORDER_DIALOG_HEADLINE: 'Para comenzar, elige una ubicación',
  ORDER_ETA_HEADING_X: '¿Cuándo estará lista esta orden para {value}?',
  ORDER_ETA_UPDATED_X: 'Debido a un aumento en pedidos, la hora de recogida actualizada es <u>{value}</u>',
  ORDER_HISTORY: 'Historial de órdenes',
  ORDER_HOURS_DISCLAIMER: 'Recuerda incluir tiempo de preparación en la entrega o recogida al permitir órdenes. Por ejemplo, si la cocina cierra a las 5pm, considera limitar las órdenes a un tiempo antes para permitir la preparación y entrega.',
  ORDER_IN_TRANSIT_HEADLINE: '¡Tu pedido está en camino!',
  ORDER_NEW_DESC: 'Tu orden está siendo revisada. Una vez que se apruebe, recibirás una notificación con el estatus de tu orden.',
  ORDER_NEW_HEADLINE: '¡Recibimos tu pedido!',
  ORDER_NOTIFICATIONS: 'Notificaciones de órdenes',
  ORDER_NOW: 'Ordena ya',
  ORDER_NUM: '# de Órden',
  ORDER_NUMBER: 'Número de Órden',
  ORDER_NUMBER_REQUIRED: 'Por favor ingresa un número de orden',
  ORDER_PLACED: 'Orden realizada',
  ORDER_PLACED_BIZ_DESC: 'Se realizó un nuevo pedido en {value} para',
  ORDER_QUESTIONS: '¿Preguntas sobre tu pedido?',
  ORDER_READY_DELIVERY_DESC: 'Su pedido será entregado a',
  ORDER_READY_HEADLINE: '¡Nuestro chef está preparando tu orden!',
  ORDER_READY_PICKUP_DESC: 'Tu orden está lista para recoger en',
  ORDER_READY_PICKUP_HEADLINE: 'Tu orden está lista para ser recogida',
  ORDER_REFUND_HEADLINE: 'Tu solicitud de reembolso',
  ORDER_REJECTED_DESC: 'Lo sentimos, pero no podemos realizar tu orden. No se te cobrará nada.',
  ORDER_REJECTED_HEADLINE: 'No podemos realizar tu orden',
  ORDER_SCHEDULE: 'Horario de pedidos',
  ORDER_SCHEDULED_BIZ_DESC: 'Se realizó un nuevo pedido programado para {value} para',
  ORDER_SCHEDULING: 'Horario para ordenar',
  ORDER_SCHEDULING_DESC: 'Permitir que los clientes ordenen para una fecha y hora específica.',
  ORDER_SETTINGS: 'Configurar órdenes',
  ORDER_SUMMARY: 'Resumen de pedido',
  ORDER_TYPE: 'Tipo de orden',
  ORDER_UPDATE: 'Información sobre tu orden',
  ORDER_WILL_BE_READY_FOR_DELIVERY_TO_X_ADDRESS: 'Tu orden estará lista para entrega a las <b>{time}</b> en <b>{address}</b>',
  ORDER_WILL_BE_READY_FOR_PICKUP_AT_X_ADDRESS: 'Tu orden estará lista para recoger a las <b>{time}</b> en <b>{address}</b>',
  ORDER_X: 'Orden #{orderId}',
  ORDER_X_ACCEPTED: '<b>Orden #{orderId}</b> fue aceptada',
  ORDER_X_DELIVERED: '<b>Orden #{orderId}</b> fue entregada',
  ORDER_X_PICKED_UP: '<b>Orden #{orderId}</b> fue recogida',
  ORDER_X_PLACED: '<b>Orden #{orderId}</b> fue realizada',
  ORDER_X_READY_DELIVERY: '<b>Orden #{orderId}</b> lista para ser entregada',
  ORDER_X_READY_PICKUP: '<b>Orden #{orderId}</b> lista para ser recogida',
  ORDER_X_REFUNDED: '<b>Orden #{orderId}</b> fue reembolsada',
  ORDER_X_REJECTED: '<b>Orden #{orderId}</b> fue rechazada',
  ORDER_X_SCHEDULED: '<b>Orden #{orderId}</b> fue programada',
  OR_CHECKOUT_AS_GUEST: 'o continuar como invitado',
  OTHER: 'Otro',
  OUT_OF_STOCK: 'Agotado',
  OUT_OF_STOCK_ALL_LOCS: 'Agotado en todas las ubicaciones',
  OUT_OF_STOCK_DESC: 'Selecciona las ubicaciones en donde este artículo esté agotado',
  OUT_OF_STOCK_SETTINGS: 'Configuración de agotación',
  OVERVIEW: 'Resumen',
  PAGE_COMING_SOON: 'Nosotros',
  PAGE_COMING_SOON_DESCRIPTION: '¡Vuelve en unos días y encontrarás un nuevo diseño muy pronto!',
  PAGE_NOT_FOUND: 'Página no encontrada',
  PAGE_NOT_FOUND_DESCRIPTION: 'Lo sentimos, no pudimos',
  PAID_ORDERS: 'Ordenes pagadas',
  PASSWORD: 'Contraseña',
  PASSWORD_EXTREMELY_GUESSABLE: 'Tu contraseña es extremadamente fácil de descifrar',
  PASSWORD_SOMEWHAT_GUESSABLE: 'Tu contraseña es fácil de descifrar',
  PASSWORD_SUCCESSFULLY_RESET: 'Tu contraseña fue restablecida con éxito',
  PASSWORD_UPDATED_SUCCESSFULLY: 'Contraseña actualizada con éxito',
  PASSWORD_VERY_GUESSABLE: 'Tu contraseña es muy fácil de descifrar',
  PAST_ORDERS: 'Órdenes previas',
  PAUSE_ORDERING: 'Pausar órdenes',
  PAUSE_ORDERING_DESC: 'Utiliza esta opción para invalidar cualquier horario. Al activar, los clientes aún podrán ver el menú pero no podrán poner órdenes.',
  PAYING_METHOD_X_Y: 'PAGADO con {cardBrand} terminando en {lastFour}',
  PAYMENT: 'Detalles de Pago',
  PAYMENT_CANCELED: 'El pago fue cancelado',
  PAYMENT_FAILED: 'El pago falló',
  PAYMENT_FORM_LOAD_ERROR: 'We’re having trouble loading the payment form. Please refresh the page and try again. If the problem continues, <0>contact us</0> and we’ll be happy to help.',
  PAYMENT_INFORMATION: 'Información de pago',
  PAYMENT_METHOD: 'Forma de Pago',
  PAYMENT_METHODS: 'Formas de Pago',
  PAYOUTS: 'Pagos',
  PAYOUT_STATUS: 'Estado del pago',
  PENDING_ORDERS: 'Pedidos pendientes',
  PERM_DELETE_LOCATION: 'Eliminar ubicación permanentemente',
  PERSONAL_INFORMATION: 'Información personal',
  PHONE_NUMBER: 'Número de Teléfono',
  PHONE_NUMBER_DISCLAIMER: 'Al proveer tu número de teléfono, aceptas recibir mensajes de texto de parte de {value} sobre tu pedido. Aplican tarifas de mensajes estándar.',
  PICKED_UP: 'Recogido',
  PICKUP: 'Recogida',
  PICKUP_AT: 'Recoger en {value}',
  PICKUP_DELIVERY: 'Recogida o entrega',
  PICKUP_FROM: 'RECOGIDO de',
  PICKUP_FROM_X: 'Recogida en {value}',
  PICKUP_IN: 'Recogida en',
  PICKUP_INSTRUCTIONS: 'Instrucciones de recogida',
  PICKUP_IN_STORE: 'Recogida en tienda',
  PICKUP_SETTINGS: 'Configuración de recogida',
  PICKUP_SETTINGS_DISCLAIMER: 'Escribe instrucciones para tus clientes cuando recojan sus órdenes (ej. dónde ir, si deben proveer su nombre y número de orden, etc.)',
  PICKUP_TIME: 'Tiempo para recoger la orden',
  PICKUP_X: 'Recogida de {value}',
  PLACE_ORDER: 'Finalizar pedido',
  PLEASE_CHECK_SPAM: 'Por favor revisa tu carpeta de correo basura en caso de no recibir un mensaje dentro de 15 minutos',
  PLEASE_ENTER_A_BIGGER_NUMBER: 'Por favor ingresa un número más alto',
  PLEASE_ENTER_A_SMALLER_NUMBER: 'Por favor ingresa un número más bajo',
  PLEASE_ENTER_A_WHOLE_NUMBER: 'Por favor ingresa un número entero',
  PLEASE_ENTER_VALID_PRICE: 'Ingresa un precio válido',
  PLEASE_SELECT_A_VALID_ADDRESS: 'Por favor, seleccione una dirección válida',
  PLEASE_SET_DELIVERY_LOCATION: 'Ingresar lugar de entrega',
  PLUS_ONE: 'Más uno',
  PM: 'p.m.',
  POSTAL_CODE: 'Código Postal',
  PREFERENCES: 'Preferencias',
  PREP_TIME: 'Tiempo de preparación',
  PREP_TIME_DISCLAIMER: 'El tiempo de preparación es para indicarle al cliente cuando la orden podría estar lista. Tienes la opción de cambiar el tiempo cada vez que se reciba un pedido.',
  PRICE: 'Precio',
  PRICE_HIGHEST: 'Precio: bajo a alto',
  PRICE_LOWEST: 'Precio: alto a bajo',
  PRIMARY: 'Primaria',
  PRINT: 'Imprimir',
  PRINTING: 'Imprimiendo...',
  PRINT_RECEIPT: 'Imprimir el recibo',
  PRIVACY: 'Política de privacidad',
  PRIVACY_POLICY: 'Política de Privacidad',
  PROCESSED: 'Procesado',
  PROCESSING: 'Procesando',
  PROCESSING_ERROR: 'Ocurrió un error al procesar tu tarjeta. Vuelve a intentarlo en un rato.',
  PRODUCTS: 'Productos',
  PRODUCT_INFORMATION: 'Información del producto',
  PRODUCT_NOT_AVAILABLE: '{product} no está disponible.',
  PRODUCT_NOT_AVAILABLE_AT_SELECTED_TIME: 'Algunos artículos en tu bolsa no están disponibles durante el tiempo seleccionado. Si continúas, es posible que estos artículos se eliminen de tu pedido.',
  PRODUCT_SOLD_OUT_ERROR: 'Disculpa las molestias. Este artículo está agotado o ya no está disponible.',
  PROFILE: 'Perfil',
  QUANTITY: 'Cantidad',
  READY: 'Listo',
  READY_DELIVERY: 'Listo para Entrega',
  READY_PICKUP: 'Listo para Recoger',
  RECEIVED_X: 'Recibida en {x}',
  RECENT_TRANSACTIONS: 'Transacciones recientes',
  REFUND: 'Reembolsar',
  REFUNDED: 'Reembolsado',
  REFUND_DESC: 'Hemos procesado tu solicitud de reembolso. Toma en cuenta que el dinero puede tardar hasta <strong>5 días hábiles</strong> para aparecer en tu cuenta.',
  REFUND_ISSUED_SUCCESS: 'Reembolso emitido con éxito',
  REFUND_PAYMENT: 'Reembolsar pago',
  REGISTER: 'Regístrate',
  REGISTER_NOW: 'Regístrese ahora ›',
  REJECT: 'Rechazar',
  REJECTED: 'Rechazada',
  REJECTED_: 'Rechazado',
  REJECTED_ON_X: 'Rechazada en {date}',
  REJECTED_ORDERS: 'Ordenes rechazadas',
  REJECT_ORDER_X: 'Rechazar orden #{orderId}',
  REMOVE: 'Remover',
  REMOVE_ADDRESS: 'Eliminar dirección',
  REMOVE_IMAGE: 'Remover Imagen',
  REMOVE_USER: 'Eliminar Usuario',
  REMOVE_USER_CONFIRMATION: '¿Estás seguro de que quieres eliminar a este usuario?',
  REMOVE_X: 'Eliminar { value }',
  REORDER: 'Reordenar',
  REQUESTED_BY_CUSTOMER: 'Solicitado por el cliente',
  REQUIRED: 'Requerido',
  RESET_PASSWORD_SENT_DESC: 'Hemos enviado un enlace para restablecer tu contraseña al correo electrónico proveído',
  RESET_YOUR_PASSWORD: 'Restablecer contraseña',
  RESTAURANT_SETTINGS: 'Configuración del restaurante',
  RETURNING_CUSTOMERS: 'Clientes recurrentes',
  REVENUE: 'Ingresos',
  REVIEW: 'Revisar',
  REVIEW_ORDER_DESC: 'Revisar dirección, forma de pago y propina antes de confirmar tu pedido.',
  REVIEW_ORDER_DESC_NO_TIP: 'Revisa la dirección y forma de pago antes de confirmar tu pedido.',
  ROLE: 'Rol',
  SAT: 'Sábado',
  SATURDAY: 'Sábado',
  SAVE: 'Guardar',
  SAVE_CONTINUE: 'Guardar y continuar',
  SAVE_PAYMENT_DESC: 'Guardar esta forma de pago para transacciones futuras',
  SAVING_USER: 'Guardando usuario',
  SCHEDULED: 'Programado',
  SCHEDULED_ACCEPTED: 'Programado',
  SCHEDULED_FOR_X: 'Programado para el {value}',
  SCHEDULED_ORDER: 'Orden programada',
  SCHEDULED_ORDERS: 'Ordenes programadas',
  SCHEDULED_REVIEW: 'Programado',
  SEARCH: 'Buscar',
  SEARCH_FOOD: 'Buscar comida',
  SEARCH_ORDERS: 'Buscar órdenes',
  SEE_ALL_F: 'Ver todas',
  SELECTING_DIFFERENT_LOCATION_CLEAR_CART: 'Al cambiar la ubicación se eliminarán los artículos en tu cesta',
  SELECT_ALL: 'Marcar Todos',
  SELECT_AN_OPTION: 'Selecciona una opción',
  SELECT_A_REASON: 'Seleccionar una razón',
  SELECT_AT_LEAST: 'Seleccione al menos {count}',
  SELECT_BETWEEN: 'Seleccione de {min} a {max}',
  SELECT_EXACTLY: 'Seleccione exactamente {count}',
  SELECT_N: 'Seleccione {count}',
  SELECT_UP_TO: 'Seleccione hasta {count}',
  SELECT_DELIVERY_ADDRESS: 'Selecciona una dirección de entrega',
  SELECT_DELIVERY_ADDRESS_CONTINUE: 'Selecciona una dirección de entrega para continuar',
  SELECT_IMAGE: 'Elegir Imagen',
  SELECT_LOCATIONS_MIN_ONE: 'Seleccionar ubicaciones (Por lo menos una)',
  SELECT_LOCATION_NEAR: 'Elige una ubicación cerca de',
  SELECT_LOCATION_TO_ORDER: 'Selecciona una ubicación para empezar a ordenar',
  SELECT_OPTION: 'Seleccionar una opción',
  SELECT_ORDER_REJECT_REASON: 'Seleccionar motivo',
  SELECT_PICKUP_LOCATION: 'Seleccione el lugar de recogida',
  SELECT_TIME: 'Elegir tiempo',
  SELECT_X_DAY: 'Seleccionar día de {value}',
  SELECT_X_FREE: 'Selecciona <b>{value}</b> gratis',
  SELECT_X_TIME: 'Elegir tiempo de {value}',
  SETTINGS: 'Configuración',
  SET_AS_DEFAULT_X: 'Establecer como {value} predeterminado',
  SET_AS_PRIMARY: 'Establecer como principal',
  SET_AS_PRIMARY_ADDRESS: 'Guardar como dirección primaria',
  SET_AS_PRIMARY_PAYMENT_METHOD: 'Guardar como forma de pago principal',
  SHIPPING_CALCULATED_CHECKOUT: 'Envío e impuestos calculados al finalizar la compra.',
  SHOPPING_CART: 'Carrito de pedidos',
  SHORT_DATE_WITH_TIME: '{date} {\'@\'} {time}',
  SHOW_DETAILS: 'Mostrar detalles',
  SHOW_STATS_FOR: 'Mostrar datos de',
  SIGNED_IN_AS: 'Sesión iniciada como',
  SIGN_IN_ACCOUNT: 'Inicia sesión en tu cuenta',
  SIGN_UP: 'Regístrate',
  SMS_ORDER_SCHEDULED: 'Una orden ha sido programada para {date} para {locationName}',
  SMS_READY_PICKUP_ECOM_ORDER: 'Tu orden está lista para recoger en {name} - {address}',
  SMS_REFUND_ECOM_ORDER: 'Hemos emitido un reembolso de {value} para la orden #{orderId}',
  SOMETHING_WENT_WRONG: 'Lo sentimos, hubo un error. Por favor intenta de nuevo.',
  SPECIAL_INSTRUCTIONS: 'Instrucciones especiales',
  SPECIAL_INSTRUCTIONS_DISCLAIMER: 'Favor de tomar en cuenta que pedidos especiales pueden resultar en un ajuste de precio después de que tu orden sea procesada.',
  SPICY_EXTRA: 'Picante: extra ardiente',
  SPICY_HOT: 'Picante: ardiente',
  SPICY_MEDIUM: 'Picante: mediano',
  SPICY_MILD: 'Picante: leve',
  START_DATE: 'Fecha de Inicio',
  START_TYPING: 'Empezar a escribir...',
  STATE: 'Estado/Provincia',
  STATE_REQ: 'Favor de ingresar el estado/provincia',
  STATUS: 'Estado',
  STORES_NEAR_X: 'Tiendas cerca de {value}',
  STORE_IS_CURRENTLY_CLOSED: 'La tienda está cerrada',
  STREET_ADDRESS: 'Dirección',
  SUBMIT: 'Someter',
  SUBTOTAL: 'Subtotal',
  SUITE_APT_ETC: 'Suite, apartamento, etc.',
  SUN: 'domingo',
  SUNDAY: 'Domingo',
  SUPER_ADMIN: 'Super administrador',
  SUPER_ADMINS: 'Super administradores',
  TAP_FIND_NEAREST_LOCATION: 'Toca aquí para encontrar la ubicacón más cerca',
  TAXES: 'Impuestos',
  TAXES_FEES: 'Impuestos y honorarios',
  TAX_RATE: 'Tasa impositiva',
  TECHNICAL_ERROR: 'Error técnico',
  TERMS_OF_SERVICE: 'Términos de Servicio',
  THANK_YOU: '¡Gracias!',
  THIS_WEEK: 'Esta semana',
  THU: 'jueves',
  THURSDAY: 'Jueves',
  TIME: 'Tiempo',
  TIMEZONE: 'Zona Horaria',
  TIP: 'Propina',
  TIP_AMOUNT: 'Monto de propina',
  TODAY: 'Hoy',
  TOKEN_EXPIRED_48_HOURS: 'Este enlace ha expirado después de 48 horas',
  TOKEN_EXPIRED_DESC: 'El enlace que has tratado de acceder no está disponible. Favor de solicitar un nuevo enlace',
  TOTAL: 'Total',
  TOTAL_ORDERS: 'Total de Órdenes',
  TOTAL_PAID_ORDERS: 'Total de órdenes pagadas',
  TOTAL_REVENUE: 'Total de Ingresos',
  TO_YOUR_ACCOUNT_OR: 'a tu cuenta o',
  TRY_PLACE_ORDER_AGAIN: 'Puedes intentar realizar tu orden nuevamente',
  TUE: 'martes',
  TUESDAY: 'Martes',
  TWENTY_FOUR_HOURS: '24 horas',
  UNABLE_PROCESS_PAYMENT_DESC: 'Hubo un error al procesar el pago de tu orden. Nos disculpamos por cualquier inconveniente. No se te cobrará.',
  UNABLE_PROCESS_PAYMENT_HEADLINE: 'No pudimos procesar tu pago',
  UNABLE_TO_ADD_PAYMENT_METHOD: 'Numero de tarjeta invalido',
  UNARCHIVE_ACCOUNT: 'Desarchivar cuenta',
  UNARCHIVE_LOCATION: 'Desarchivar ubicación',
  UN_SELECT_ALL: 'Desmarcar Todos',
  UPDATE: 'Actualizar',
  USER: 'Usuario',
  USERNAME: 'Nombre de usuario',
  USERS: 'Usuarios',
  USER_ACCESS: 'Acceso de Usuarios',
  USER_ALREADY_EXISTS: 'El usuario ya existe ',
  USER_HAS_NO_EMAIL: 'Este usuario no tiene un correo electrónico',
  USER_PERMISSIONS: 'Permisos de usuario',
  USER_PERMISSIONS_DESC: 'Administra los permisos para otorgar o remover acceso a ciertas funciones del tablero, dependiendo del rol de usuario',
  VEGAN: 'Vegano',
  VEGETARIAN: 'Vegetariano',
  VIEW: 'Ver',
  VIEWS: 'Vistas',
  VIEW_ALL: 'Ver Todos',
  VIEW_ALL_F: 'Ver Todas',
  VIEW_MAP: 'Ver el mapa',
  VIEW_MORE: 'Ver Más',
  VIEW_ORDER: 'Ver orden',
  VIEW_ORDER_HISTORY: 'Ver historial de órdenes',
  VIEW_OUR_MENU_URL: 'Visita nuestro menú en { value }',
  VIEW_PAYOUTS_ON_STRIPE: 'Ver desembolsos en Stripe',
  VIEW_RECEIPT: 'Ver recibo',
  VIEW_STORE_INFO: 'Ver información del negocio',
  VIEW_STRIPE_ACCOUNT: 'Ver cuenta de Stripe',
  WARN_MIN_ORDER_CHECKOUT: 'Necesitas {value} para realizar una orden',
  WED: 'miércoles',
  WEDNESDAY: 'Miércoles',
  WE_SENT_AN_EMAIL_TO: 'Enviamos un correo eléctronico a',
  WRITE_INSTRUCTIONS: 'Escribir instrucciones',
  WRITE_SPECIAL_INSTRUCTIONS: 'Escribir instrucciones especiales',
  X_AMOUNT_FROM_FREE_DELIVERY: '¡Sólo <b>{amount}</b> para entrega gratuita!',
  X_FOR_Y: '{name} para {value}',
  X_ITEMS: '{value} artículos',
  X_ITEMS_IN_YOUR_BAG: '{value} artículos en la bolsa',
  X_MINUTES: '{value} minutos',
  X_MIN_AMOUNT_DELIVERY: 'Compra mínima de {value} para entrega',
  X_ORDERS: '{amount} ordenes',
  X_SELECTED_F: '{value} seleccionadas',
  X_SELECTED_M: '{value} seleccionados',
  X_TIP: 'Propina de {value}%',
  YES: 'Sí',
  YESTERDAY: 'Ayer',
  YES_DELETE: 'Sí, borrar',
  YOUR_ADDRESSES: 'Tus direcciones',
  YOUR_ORDER: 'Tu orden',
  YOUR_ORDER_BEING_PREPARED: '<b>Your order</b> está siendo preparada',
  YOUR_ORDER_BEING_PROCESSED: '<b>Tu orden</b> está siendo procesada',
  YOUR_ORDER_ON_WAY_DELIVERY: '<b>Tu orden</b> está en camino',
  YOUR_ORDER_READY_DELIVERY: '<b>Tu orden</b> está lista',
  YOUR_ORDER_READY_PICKUP: '<b>Tu orden</b> está lista para recoger',
  YOUR_ORDER_REFUNDED: '<b>Tu orden</b> fue reembolsada',
  YOUR_PAYMENT_METHODS: 'Tus formas de pago',
  YOU_HAVE_NO_ADDRESSES: 'No tienes direcciones',
  ZIP_CODE: 'Código postal',
}
export default es
